export const StkWallet = [
  'function wrapAll()',
  'function wrap(uint256 shareAmount)',
  'function unwrap(uint256 shareAmount)',
  'function enter(uint256 amount)'
]
